import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';
import { FeatureGuard } from '@camelot/user';

export enum EItemsRoute {
  items = 'items',
  list = 'list',
  families = 'families',
  compositions = 'compositions',
  view = 'view',
  familyView = 'familyView',
  compositionView = 'compositionView',
}

CamRoutes.addRoute({
  key: EItemsRoute.items,
  url: 'items',
  children: [
    {
      key: EItemsRoute.list,
      url: 'list',
    },
    {
      key: EItemsRoute.families,
      url: 'families',
    },
    {
      key: EItemsRoute.compositions,
      url: 'compositions',
    },
    {
      key: EItemsRoute.view,
      url: 'view/:id',
    },
    {
      key: EItemsRoute.familyView,
      url: 'family/:id',
    },
    {
      key: EItemsRoute.compositionView,
      url: 'composition/:id',
    },
  ],
});

export const itemsRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.list]),
    pathMatch: 'full',
  },
  {
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.list]),
    loadComponent: () => import('./pages/list/items-list.component').then(c => c.ItemsListPage),
  },
  {
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.families]),
    loadComponent: () => import('./pages/families-list/item-families-list.component').then(c => c.ItemFamiliesListPage),
  },
  {
    canActivate: [FeatureGuard],
    data: { permissions: ['read:composition'] },
    loadComponent: () =>
      import('./pages/compositions-list/item-compositions-list.component').then(c => c.ItemCompositionsListPage),
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.compositions]),
  },
  {
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.view]),
    loadComponent: () => import('./pages/view/item-view.component').then(c => c.ItemViewPage),
  },
  {
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.familyView]),
    loadComponent: () => import('./pages/family-view/item-family-view.component').then(c => c.ItemFamilyViewPage),
  },
  {
    canActivate: [FeatureGuard],
    data: { permissions: ['read:composition'] },
    loadComponent: () =>
      import('./pages/composition-view/item-composition-view.component').then(c => c.ItemCompositionViewPage),
    path: CamRoutes.getUrl([EItemsRoute.items, EItemsRoute.compositionView]),
  },
];
